// Generated by ReScript, PLEASE EDIT WITH CARE


var paymentFailed = "Payment failed";

var packersAndMovers = "Packers & Movers";

var bookingAmountToPay = "Booking amount to pay";

var note = "Note:";

var paymentFailureDesc = "Any amount deducted will be automatically refunded to the source account in 7-10 business days.";

var close = "Close";

var paymentFailureImgUrl = "https://dom-content-vault-prod-cdn-assets.porter.in/payment_failure_57b845ed2a/payment_failure_57b845ed2a.svg";

export {
  paymentFailed ,
  packersAndMovers ,
  bookingAmountToPay ,
  note ,
  paymentFailureDesc ,
  close ,
  paymentFailureImgUrl ,
}
/* No side effect */
